import React from 'react';
import Select from 'react-select';
import { reactSelectStyles } from './styles';

// Searchable single-select (type-to-filter), for acknowledgement name fields
// that must be picked from a known list rather than typed freely (UAT MoM #12).
const SingleSearchSelect = ({ value, options, onChange, isLoading = false, placeholder, noOptionsMessage }) => (
  <Select
    classNamePrefix="audit-form-select"
    styles={reactSelectStyles}
    value={options.find((o) => o.value === value) || (value ? { value, label: value } : null)}
    options={options}
    onChange={(selected) => onChange(selected?.value || '')}
    isLoading={isLoading}
    isClearable
    placeholder={placeholder}
    noOptionsMessage={noOptionsMessage}
    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
  />
);

export default SingleSearchSelect;
